import {createContext} from 'react'

import type {ExperimentScope, ExperimentStore} from './store-types'

export const ExperimentStoreContext = createContext<ExperimentStore | null>(null)
export const ExperimentScopeContext = createContext<ExperimentScope | null>(null)
